export default __webpack_public_path__ + "static/media/appInfoBackground.d28f07ee.png";